import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
interface RevealProps {
  children: React.ReactNode;
  delay?: number;
  className?: string;
  as?: 'div' | 'section' | 'li' | 'article' | 'header';
}

/** Restrained scroll reveal: a short upward fade, once, never longer than 300ms. */
export function Reveal({
  children,
  delay = 0,
  className,
  as = 'div'
}: RevealProps) {
  const reduced = useReducedMotion();
  const Component = motion[as];
  if (reduced) {
    const Plain = as;
    return <Plain className={className} data-id="element-175" data-mp="2nri8sc8qz89y">{children}</Plain>;
  }
  return <Component className={className} initial={{
    opacity: 0,
    y: 14
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-60px'
  }} transition={{
    duration: 0.3,
    delay,
    ease: [0.23, 1, 0.32, 1]
  }} data-id="element-176" data-mp="2nu4ioij41zvc">
      {children}
    </Component>;
}